import { AgGridAngular } from '@ag-grid-community/angular';
import { Directive, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { StickyGridService } from './sticky-grid.service';

@Directive({
  providers: [StickyGridService],
  selector: '[auxStickyGrid]',
  standalone: true,
})
export class StickyGridDirective {
  grid = inject(AgGridAngular);
  stickyElementService = inject(StickyGridService);

  onScrollAndResize = merge(fromEvent(window, 'scroll'), fromEvent(window, 'resize'));

  stickyOffset = input(0);

  constructor() {
    merge(
      this.grid.gridReady,
      this.grid.firstDataRendered,
      this.grid.viewportChanged,
      this.grid.gridSizeChanged,
      this.onScrollAndResize
    )
      .pipe(debounceTime(20))
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.stickyElementService.configure(this.grid.api.getDisplayedRowCount() - 1, {
          offset: this.stickyOffset(),
        });
      });
  }
}
